export default __webpack_public_path__ + "static/media/u.de0a7145.svg";